import { isValidEmail } from '@/utils/validator';

export const useValidation = (
  fieldsToValidate,
  data,
  conditionMet,
  conditionField
) => {
  const supportedfields = ['company', 'companyEmail'];
  const fieldsWithValues = {};
  [...fieldsToValidate, ...(conditionMet ? [conditionField] : [])].forEach(
    (el) => {
      fieldsWithValues[el] = data[el]?.toString() || '';
    }
  );
  const validationData = {};
  [...fieldsToValidate, ...(conditionMet ? [conditionField] : [])].forEach(
    (field) => {
      if (supportedfields.includes(field)) {
        if (field === 'companyEmail') {
          validationData[field] = isValidEmail(fieldsWithValues[field]);
        } else {
          validationData[field] = fieldsWithValues[field].length > 0;
        }
      }
    }
  );
  const isValid = [
    ...fieldsToValidate,
    ...(conditionMet ? [conditionField] : []),
  ].every((el) => validationData[el] === true);
  return { isValid, validationData };
};
